import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'highlight'
})
export class HighlightPipe implements PipeTransform {
  public startTag = '<span class="yellowhighlight">';
  public endTag = '</span>';

  transform(value: string | null | undefined, args?: string): string | null {
    if (value === null || typeof value === 'undefined') { return null; }
    if (typeof args === 'undefined') { return value; }

    let searchTerms: string[] = [];
    let result = value;

    const arr = value.split(/[,.;]| /);
    const termsToHighlight = args.split(' ');
    termsToHighlight.forEach(a => {
      searchTerms = searchTerms.concat(a.split(' '));
    });

    arr.forEach(val => {
      result = searchTerms.reduce((acc, t) => {
        if (val.toUpperCase().indexOf(t.toUpperCase()) > -1) {
          const reg = new RegExp('(?<!<[^>]*)(' + t + ')', 'gi');
          return acc.replace(reg, `${this.startTag}$1${this.endTag}`);
        } else {
          return acc;
        }
      }, result);
    });

    return result;
  }

}
